import EmptyCartComp from "./EmptyCartComp";

export default EmptyCartComp;
